export default "__VITE_ASSET__CUEwgync__"